import { createFileRoute } from '@tanstack/react-router';
import { AdminAuditLogs } from '../../components/admin/admin-audit-logs';

export const Route = createFileRoute('/admin/audit-logs')({
  component: AdminAuditLogs,
});
